import React, { PropsWithChildren } from 'react';
import { Tag } from 'ts-ioc-container';
import { ContainerContext, useContextOrFail } from './ContainerContext';

export function Scope({ tags, children }: PropsWithChildren<{ tags?: Tag[] }>): JSX.Element {
  const container = useContextOrFail(ContainerContext);
  return <ContainerContext.Provider value={container.createScope(tags)}>{children}</ContainerContext.Provider>;
}
